export const translations = {
  en: {
    // Navbar
    nav: {
      solutions: 'Solutions',
      programs: 'Challenges',
      pricing: 'Pricing',
      dashboard: 'Dashboard',
      apply: 'Apply Now'
    },
    
    // Home Page
    home: {
      hero: {
        title: 'Don\'t Evaluate Alone. Evaluate with Humans + AI',
        tagline: 'Publish challenges, evaluate with multiple perspectives, and make faster, more reliable decisions.',
        description: '',
        subtitle: 'Publish challenges, evaluate with multiple perspectives, and make faster, more reliable decisions.',
        noFriction: 'No long contracts. No mandatory consulting. No friction.',
        ctaPrimary: 'Publish a Challenge',
        ctaSecondary: 'View Active Challenges',
        tag1: 'Self-Serve Platform',
        tag2: 'Open Innovation',
        tag3: 'Simple Management'
      },
      about: {
        title: 'The simplest way to manage innovation challenges in Chile',
        description: 'ColaboraChile is a platform that allows you to structure, publish, and manage innovation challenges in an organized and professional way.',
        belief: 'We believe innovation doesn\'t need bureaucracy or complex processes: it needs clear structure and simple tools.',
        cta: 'Learn More'
      },
      howItWorks: {
        title: 'How It Works',
        subtitle: 'Publish. Evaluate. Select.',
        step1: {
          title: 'Define your challenge',
          description: 'Use our guided templates to structure your challenge clearly'
        },
        step2: {
          title: 'Publish and receive applications',
          description: 'Your challenge goes live on the platform with everything applicants need to understand what you\'re looking for and how to apply.'
        },
        step3: {
          title: 'Evaluate with humans + AI',
          description: 'Assign human evaluators and activate AI evaluators to get multiple perspectives on each application. Compare scores and comments across all evaluators.'
        },
        step4: {
          title: 'Select the best applicants',
          description: 'Make faster, more reliable decisions backed by combined human and AI evaluations'
        },
        footer: 'All from one place, with total control.'
      },
      model: {
        title: 'A Professional Tool for Open Innovation',
        description: 'Publish challenges, evaluate with AI and human experts, and select the best applicants — all from a single platform.',
        free: 'For solvers, applying is always free.'
      },
      features: {
        title: 'What We Offer',
        subtitle: 'Everything you need to capture, evaluate, and select the best applicants',
        feature1: {
          title: 'Publish Challenges',
          description: 'Create and publish clear challenges using templates that help you define the problem well and structure the information.'
        },
        feature2: {
          title: 'Receive Applications',
          description: 'Access all applications received, without limits or intermediaries.'
        },
        feature3: {
          title: 'AI Evaluators',
          description: 'Activate expert AI evaluators that score and comment each application with multiple perspectives. Available from Starter plan.'
        },
        feature4: {
          title: 'Evaluation Dashboard',
          description: 'Compare human and AI evaluator scores side by side. Read detailed comments per criterion for every application.'
        },
        moreSupport: 'Need more support? You can add curation services, workshops, or complete management whenever you want.'
      },
      pricing: {
        title: 'A Simple, Transparent Model',
        subtitle: 'Three plans. Monthly payment. No long contracts.',
        toggle: {
          monthly: 'Monthly',
          annual: 'Annual',
          save: 'Save 2 months'
        },
        plans: {
          starter: {
            name: 'Starter',
            monthlyPrice: '39',
            annualPrice: '390',
            tagline: 'Ideal for SMEs, municipalities, universities, and innovation teams getting started.',
            features: [
              'Unlimited challenges',
              'Multiple AI evaluators to pre-evaluate applications',
              'Guided templates to define your challenge',
              'Public page for each challenge',
              'Full access to all applications received',
              'Simple tracking dashboard',
              'Immediate publication (no sales validation)'
            ],
            notIncluded: [
              'Solution curation',
              'Dedicated human support',
              'Workshops or consulting'
            ],
            cta: 'Start Now'
          },
          growth: {
            name: 'Growth',
            monthlyPrice: '129',
            annualPrice: '1,290',
            tagline: 'For organizations that want more structure and support.',
            includesStarter: 'Everything in Starter plus:',
            features: [
              'Expert review of up to 2 challenges per year (included)',
              'Featured on challenges page',
              'Basic application reporting',
              'Email support with 48hr response'
            ],
            notIncluded: [
              'Full application curation',
              'Strategic workshops',
              'Dedicated support'
            ],
            idealFor: 'Ideal for: Mid-size companies, trade associations, public institutions with innovation budget.',
            cta: 'View Plan'
          },
          pro: {
            name: 'Pro',
            monthlyPrice: '299',
            annualPrice: '2,990',
            tagline: 'For organizations that need scale and strategic support.',
            includesGrowth: 'Everything in Growth plus:',
            features: [
              'Full application curation included',
              'Strategic workshops (up to 2 per year included)',
              'Dedicated support with direct contact',
              'Advanced reporting with data export',
              'Top priority in challenge listing'
            ],
            idealFor: 'Ideal for: Large corporations, financial institutions, utilities.',
            cta: 'Talk to Us'
          }
        },
        period: {
          month: 'month',
          year: 'year'
        },
        addons: {
          title: 'Optional Services (Add-ons)',
          subtitle: 'Complement your management with additional services',
          availableNote: 'Available for Starter and Growth plans. Included in Pro Plan.',
          items: [
            {
              name: 'Expert Challenge Review',
              price: 'USD 200',
              description: 'An expert reviews and improves your challenge definition'
            },
            {
              name: 'Application Curation',
              price: 'USD 400–600',
              description: 'Analysis and pre-selection of the best applications'
            },
            {
              name: 'Strategic Focus Workshop (4 hrs)',
              price: 'USD 600',
              description: 'Facilitated session to define objectives and criteria'
            },
            {
              name: 'Complete Challenge Management',
              price: 'From USD 1,500',
              description: 'We handle the entire process from start to finish'
            }
          ]
        }
      },
      stats: {
        title: 'The Ecosystem is Already Active',
        stat1: 'published challenges',
        stat2: 'applications received',
        stat3: 'participating organizations',
        stat4: 'ecosystem innovators'
      },
      cta: {
        title: 'Start Evaluating Smarter Today',
        description: 'ColaboraChile is for organizations that want to act, not just talk about innovation.',
        action: 'Publish your first challenge and let AI help you find the best applicants.',
        button: 'Start Now'
      }
    },
    
    // Programs Page
    programs: {
      title: 'Browse Challenges',
      subtitle: 'Discover innovation challenges, competitions, and accelerators from around the world.',
      search: 'Search challenges...',
      showing: 'Showing',
      programs: 'challenges',
      noResults: 'No challenges found matching your criteria.',
      status: {
        open: 'Open',
        closed: 'Closed'
      },
      deadline: 'Deadline',
      applicants: 'applicants',
      viewDetails: 'View Details',
      categories: {
        all: 'All',
        technology: 'Technology',
        healthcare: 'Healthcare',
        sustainability: 'Sustainability',
        education: 'Education',
        finance: 'Finance'
      }
    },
    
    // Program Detail
    programDetail: {
      backToPrograms: 'Back to Challenges',
      applicationsOpen: 'Applications Open',
      applicationsClosed: 'Applications Closed',
      aboutProgram: 'About the Challenge',
      applicationProcess: 'Application Process',
      eligibility: 'Eligibility',
      prizeAmount: 'Prize Amount',
      applicationDeadline: 'Application Deadline',
      location: 'Location',
      totalApplicants: 'Total Applicants',
      applyNow: 'Apply Now',
      closesIn: 'Applications close in',
      days: 'days'
    },
    
    // Apply Page
    apply: {
      title: 'Apply to a Challenge',
      subtitle: 'Fill out the application form below to apply to your chosen innovation challenge.',
      formTitle: 'Application Form',
      selectProgram: 'Select Challenge',
      chooseProgram: 'Choose a challenge',
      loading: 'Loading challenges...',
      noPrograms: 'No open challenges available',
      startupInfo: 'Startup Information',
      startupName: 'Startup Name',
      website: 'Website',
      description: 'Startup Description',
      descriptionPlaceholder: 'Describe your startup, the problem you\'re solving, and your solution...',
      stage: 'Startup Stage',
      selectStage: 'Select stage',
      teamSize: 'Team Size',
      fundingRaised: 'Funding Raised (USD)',
      founderInfo: 'Founder Information',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone Number',
      additionalMaterials: 'Additional Materials',
      pitchDeck: 'Pitch Deck (PDF)',
      pitchDeckHelp: 'Upload your pitch deck in PDF format (optional)',
      submitting: 'Submitting...',
      submit: 'Submit Application',
      stages: {
        idea: 'Idea Stage',
        prototype: 'Prototype',
        mvp: 'MVP',
        earlyRevenue: 'Early Revenue',
        growth: 'Growth Stage'
      },
      success: {
        title: 'Application Submitted!',
        description: 'Your application has been successfully submitted. We\'ll review it and get back to you soon.'
      },
      error: {
        title: 'Submission Failed',
        description: 'There was an error submitting your application. Please try again.'
      }
    },
    
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome back',
      newApplication: 'New Application',
      totalPrograms: 'Total Challenges',
      activePrograms: 'Active Challenges',
      totalApplications: 'Total Applications',
      avgScore: 'Avg Score',
      tabs: {
        programs: 'My Challenges',
        applications: 'Applications',
        analytics: 'Analytics'
      },
      programsTab: {
        title: 'Challenges',
        view: 'View'
      },
      applicationsTab: {
        title: 'Recent Applications',
        startupName: 'Startup Name',
        program: 'Challenge',
        submitted: 'Submitted',
        status: 'Status',
        score: 'Score',
        pending: 'Pending'
      },
      analyticsTab: {
        topCategories: 'Top Categories',
        applicationsByMonth: 'Applications by Month'
      }
    },
    
    // Solutions Page
    solutions: {
      hero: {
        title: 'Plans and Pricing',
        subtitle: 'Publish challenges, evaluate with humans + AI, and select the best applicants.'
      },
      toggle: {
        monthly: 'Monthly',
        annual: 'Annual',
        save: 'Save 2 months'
      },
      plans: {
        starter: {
          name: 'Starter',
          monthlyPrice: '39',
          annualPrice: '390',
          tagline: 'Ideal for SMEs, municipalities, universities, and innovation teams getting started.',
          features: [
            'Unlimited challenges',
            'AI evaluators to pre-evaluate applications',
            'Guided templates to define your challenge',
            'Public page for each challenge',
            'Full access to all applications received',
            'Simple tracking dashboard',
            'Immediate publication (no sales validation)'
          ],
          notIncluded: [
            'Solution curation',
            'Dedicated human support',
            'Workshops or consulting'
          ],
          cta: 'Start Now'
        },
        growth: {
          name: 'Growth',
          monthlyPrice: '129',
          annualPrice: '1,290',
          tagline: 'For organizations that want more structure and support.',
          includesStarter: 'Everything in Starter plus:',
          features: [
            'Expert review of up to 2 challenges per year (included)',
            'Featured on challenges page',
            'Basic application reporting',
            'Email support with 48hr response'
          ],
          notIncluded: [
            'Full application curation',
            'Strategic workshops',
            'Dedicated support'
          ],
          idealFor: 'Ideal for: Mid-size companies, trade associations, public institutions with innovation budget.',
          cta: 'View Plan'
        },
        pro: {
          name: 'Pro',
          monthlyPrice: '299',
          annualPrice: '2,990',
          tagline: 'For organizations that need scale and strategic support.',
          includesGrowth: 'Everything in Growth plus:',
          features: [
            'Full application curation included',
            'Strategic workshops (up to 2 per year included)',
            'Dedicated support with direct contact',
            'Advanced reporting with data export',
            'Top priority in challenge listing'
          ],
          idealFor: 'Ideal for: Large corporations, financial institutions, utilities.',
          cta: 'Talk to Us'
        }
      },
      period: {
        month: 'month',
        year: 'year'
      },
      addons: {
        title: 'Optional Services (Add-ons)',
        subtitle: 'Complement your management with additional services',
        availableNote: 'Available for Starter and Growth plans. Included in Pro Plan.',
        items: [
          {
            name: 'Expert Challenge Review',
            price: 'USD 200',
            description: 'An expert reviews and improves your challenge definition'
          },
          {
            name: 'Application Curation',
            price: 'USD 400–600',
            description: 'Analysis and pre-selection of the best applications'
          },
          {
            name: 'Strategic Focus Workshop (4 hrs)',
            price: 'USD 600',
            description: 'Facilitated session to define objectives and criteria'
          },
          {
            name: 'Complete Challenge Management',
            price: 'From USD 1,500',
            description: 'We handle the entire process from start to finish'
          }
        ]
      },
      solvers: {
        title: 'For solvers (startups, entrepreneurs, academia)',
        price: 'Always free.',
        description: 'Applying to challenges on ColaboraChile has no cost.',
        belief: 'We believe in an open, diverse, and active ecosystem.'
      },
      faq: {
        title: 'Frequently Asked Questions',
        q1: 'Why is there no free plan to publish challenges?',
        a1: 'Because we want real challenges, from committed organizations.\nA small payment ensures serious use and quality challenges.',
        q2: 'Can I change plans at any time?',
        a2: 'Yes. You can upgrade or downgrade whenever you want. Changes apply in the next billing cycle.',
        q3: 'What if I need more help?',
        a3: 'You can add services at any time or upgrade to the Pro Plan for dedicated support.',
        q4: 'Is there a discount for annual payment?',
        a4: 'Yes. Paying annually saves you the equivalent of 2 months (~17% discount).',
        q5: 'Do I need to talk to sales?',
        a5: 'No for Starter and Growth plans.\nFor the Pro Plan, we recommend scheduling a call.'
      },
      finalCta: {
        title: 'Start managing your innovation challenges today',
        subtitle: 'No long contracts. Cancel anytime.',
        cta: 'Start Now'
      }
    },
    
    // Pricing Page
    pricing: {
      title: 'Simple, Transparent Pricing',
      subtitle: 'Choose the plan that fits your needs. Start free, upgrade as you grow.',
      mostPopular: 'Most Popular',
      perMonth: 'month',
      getStarted: 'Get Started',
      contactSales: 'Contact Sales',
      faqTitle: 'Frequently Asked Questions'
    },
    
    // Footer
    footer: {
      description: 'Open and free platform that connects innovation challenges with solutions from the national ecosystem.',
      products: 'Products',
      compete: 'ColaboraChile Compete',
      browsePrograms: 'Browse Challenges',
      pricing: 'Pricing',
      company: 'Company',
      about: 'About Us',
      contact: 'Contact',
      careers: 'Careers',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      cookies: 'Cookie Policy',
      copyright: 'All rights reserved.'
    }
  },
  
  es: {
    // Navbar
    nav: {
      solutions: 'Soluciones',
      programs: 'Desafíos',
      pricing: 'Precios',
      dashboard: 'Panel',
      apply: 'Postular'
    },
    
    // Home Page
    home: {
      hero: {
        title: 'No evalúes solo. Evalúa con Humanos + IA',
        tagline: 'Publica desafíos, evalúa con múltiples perspectivas y toma decisiones más rápidas y confiables.',
        description: '',
        subtitle: 'Publica desafíos, evalúa con múltiples perspectivas y toma decisiones más rápidas y confiables.',
        noFriction: 'Sin contratos largos. Sin consultoría obligatoria. Sin fricción.',
        ctaPrimary: 'Publicar un desafío',
        ctaSecondary: 'Ver desafíos activos',
        tag1: 'Plataforma Self-Serve',
        tag2: 'Innovación Abierta',
        tag3: 'Gestión Simple'
      },
      about: {
        title: 'La forma más simple de gestionar desafíos de innovación en Chile',
        description: 'ColaboraChile es una plataforma que te permite estructurar, publicar y gestionar desafíos de innovación de forma ordenada y profesional.',
        belief: 'Creemos que la innovación no necesita burocracia ni procesos complejos: necesita estructura clara y herramientas simples.',
        cta: 'Conocer más'
      },
      howItWorks: {
        title: 'Cómo Funciona',
        subtitle: 'Publica. Evalúa. Selecciona.',
        step1: {
          title: 'Define tu desafío',
          description: 'Usando nuestras plantillas guiadas para estructurar tu desafío de forma clara'
        },
        step2: {
          title: 'Publica y recibe postulaciones',
          description: 'Tu desafío queda disponible en la plataforma con toda la información necesaria para que los postulantes entiendan qué buscas y cómo postular.'
        },
        step3: {
          title: 'Evalúa con humanos + IA',
          description: 'Asigna evaluadores humanos y activa evaluadores IA para obtener múltiples perspectivas sobre cada postulación. Compara puntajes y comentarios de todos los evaluadores.'
        },
        step4: {
          title: 'Selecciona a los mejores',
          description: 'Toma decisiones más rápidas y confiables respaldadas por evaluaciones combinadas de humanos e IA'
        },
        footer: 'Todo desde un solo lugar, con control total.'
      },
      model: {
        title: 'Una herramienta profesional para innovación abierta',
        description: 'Publica desafíos, evalúa con IA y expertos humanos, y selecciona a los mejores postulantes — todo desde una sola plataforma.',
        free: 'Para solucionadores, postular siempre es gratis.'
      },
      features: {
        title: 'Qué Ofrecemos',
        subtitle: 'Todo lo que necesitas para capturar, evaluar y seleccionar a los mejores postulantes',
        feature1: {
          title: 'Publicar desafíos',
          description: 'Crea y publica desafíos claros usando plantillas que te ayudan a definir bien el problema y estructurar la información.'
        },
        feature2: {
          title: 'Recibir postulaciones',
          description: 'Accede a todas las postulaciones recibidas, sin límites ni intermediarios.'
        },
        feature3: {
          title: 'Evaluadores IA',
          description: 'Activa evaluadores IA expertos que puntúan y comentan cada postulación con múltiples perspectivas. Disponible desde el plan Starter.'
        },
        feature4: {
          title: 'Dashboard de evaluación',
          description: 'Compara puntajes de evaluadores humanos e IA lado a lado. Lee comentarios detallados por criterio para cada postulación.'
        },
        moreSupport: '¿Necesitas más apoyo? Puedes agregar servicios de curaduría, workshops o gestión completa cuando quieras.'
      },
      pricing: {
        title: 'Un modelo simple y transparente',
        subtitle: 'Tres planes. Pago mensual. Sin contratos largos.',
        toggle: {
          monthly: 'Mensual',
          annual: 'Anual',
          save: 'Ahorra 2 meses'
        },
        plans: {
          starter: {
            name: 'Starter',
            monthlyPrice: '39',
            annualPrice: '390',
            tagline: 'Ideal para PyMEs, municipios, universidades y equipos de innovación que quieren empezar.',
            features: [
              'Desafíos ilimitados',
              'Multiples evaluadores IA para preevaluar postulaciones',
              'Plantillas guiadas para definir bien tu desafío',
              'Página pública para cada desafío',
              'Acceso completo a todas las postulaciones recibidas',
              'Dashboard simple de seguimiento',
              'Publicación inmediata (sin validaciones comerciales)'
            ],
            notIncluded: [
              'Curaduría de soluciones',
              'Soporte humano dedicado',
              'Workshops o asesorías'
            ],
            cta: 'Comenzar ahora'
          },
          growth: {
            name: 'Growth',
            monthlyPrice: '129',
            annualPrice: '1.290',
            tagline: 'Para organizaciones que quieren más estructura y acompañamiento.',
            includesStarter: 'Todo lo del plan Starter más:',
            features: [
              'Revisión experta de hasta 2 desafíos por año (incluida)',
              'Destacado en la página de desafíos',
              'Reporting básico de postulaciones',
              'Soporte por email con respuesta en 48 hrs'
            ],
            notIncluded: [
              'Curaduría completa de postulaciones',
              'Workshops estratégicos',
              'Soporte dedicado'
            ],
            idealFor: 'Ideal para: Empresas medianas, gremios, instituciones públicas con presupuesto de innovación.',
            cta: 'Ver este plan'
          },
          pro: {
            name: 'Pro',
            monthlyPrice: '299',
            annualPrice: '2.990',
            tagline: 'Para organizaciones que necesitan escala y acompañamiento estratégico.',
            includesGrowth: 'Todo lo del plan Growth más:',
            features: [
              'Curaduría completa de postulaciones incluida',
              'Workshops estratégicos (hasta 2 al año incluidos)',
              'Soporte dedicado con contacto directo',
              'Reporting avanzado con exportación de datos',
              'Máxima prioridad en listado de desafíos'
            ],
            idealFor: 'Ideal para: Grandes empresas, corporativos, instituciones financieras, utilities.',
            cta: 'Habla con nosotros'
          }
        },
        period: {
          month: 'mes',
          year: 'año'
        },
        addons: {
          title: 'Servicios opcionales (Add-ons)',
          subtitle: 'Complementa tu gestión con servicios adicionales',
          availableNote: 'Disponible para planes Starter y Growth. Incluido en Plan Pro.',
          items: [
            {
              name: 'Revisión experta del desafío',
              price: 'USD 200',
              description: 'Un experto revisa y mejora la definición de tu desafío'
            },
            {
              name: 'Curaduría de postulaciones',
              price: 'USD 400–600',
              description: 'Análisis y preselección de las mejores postulaciones'
            },
            {
              name: 'Workshop de foco estratégico (4 hrs)',
              price: 'USD 600',
              description: 'Sesión facilitada para definir objetivos y criterios'
            },
            {
              name: 'Gestión completa del desafío',
              price: 'Desde USD 1.500',
              description: 'Nos encargamos de todo el proceso de principio a fin'
            }
          ]
        }
      },
      stats: {
        title: 'El ecosistema ya está activo',
        stat1: 'desafíos publicados',
        stat2: 'postulaciones recibidas',
        stat3: 'organizaciones participantes',
        stat4: 'innovadores del ecosistema'
      },
      cta: {
        title: 'Empieza a evaluar de forma más inteligente hoy',
        description: 'ColaboraChile es para organizaciones que quieren hacer, no solo hablar de innovación.',
        action: 'Publica tu primer desafío y deja que la IA te ayude a encontrar a los mejores postulantes.',
        button: 'Comenzar ahora'
      }
    },
    
    // Programs Page
    programs: {
      title: 'Explorar Desafíos',
      subtitle: 'Descubre competencias de startups, aceleradores y desafíos de innovación de todo el mundo.',
      search: 'Buscar desafíos...',
      showing: 'Mostrando',
      programs: 'desafíos',
      noResults: 'No se encontraron desafíos que coincidan con tus criterios.',
      status: {
        open: 'Abierto',
        closed: 'Cerrado'
      },
      deadline: 'Fecha límite',
      applicants: 'postulantes',
      viewDetails: 'Ver Detalles',
      categories: {
        all: 'Todos',
        technology: 'Tecnología',
        healthcare: 'Salud',
        sustainability: 'Sustentabilidad',
        education: 'Educación',
        finance: 'Finanzas'
      }
    },
    
    // Program Detail
    programDetail: {
      backToPrograms: 'Volver a Desafíos',
      applicationsOpen: 'Postulaciones Abiertas',
      applicationsClosed: 'Postulaciones Cerradas',
      aboutProgram: 'Acerca del Desafío',
      applicationProcess: 'Proceso de Postulación',
      eligibility: 'Elegibilidad',
      prizeAmount: 'Monto del Premio',
      applicationDeadline: 'Fecha Límite de Postulación',
      location: 'Ubicación',
      totalApplicants: 'Total de Postulantes',
      applyNow: 'Postular Ahora',
      closesIn: 'Las postulaciones cierran en',
      days: 'días'
    },
    
    // Apply Page
    apply: {
      title: 'Postular a un Desafío',
      subtitle: 'Completa el formulario de postulación a continuación para postular al desafío de innovación elegido.',
      formTitle: 'Formulario de Postulación',
      selectProgram: 'Seleccionar Desafío',
      chooseProgram: 'Elige un desafío',
      loading: 'Cargando desafíos...',
      noPrograms: 'No hay desafíos abiertos disponibles',
      startupInfo: 'Información de la Startup',
      startupName: 'Nombre de la Startup',
      website: 'Sitio Web',
      description: 'Descripción de la Startup',
      descriptionPlaceholder: 'Describe tu startup, el problema que resuelves y tu solución...',
      stage: 'Etapa de la Startup',
      selectStage: 'Seleccionar etapa',
      teamSize: 'Tamaño del Equipo',
      fundingRaised: 'Financiamiento Recaudado (USD)',
      founderInfo: 'Información del Fundador',
      fullName: 'Nombre Completo',
      email: 'Email',
      phone: 'Número de Teléfono',
      additionalMaterials: 'Materiales Adicionales',
      pitchDeck: 'Pitch Deck (PDF)',
      pitchDeckHelp: 'Sube tu pitch deck en formato PDF (opcional)',
      submitting: 'Enviando...',
      submit: 'Enviar Postulación',
      stages: {
        idea: 'Etapa de Idea',
        prototype: 'Prototipo',
        mvp: 'MVP',
        earlyRevenue: 'Ingresos Tempranos',
        growth: 'Etapa de Crecimiento'
      },
      success: {
        title: '¡Postulación Enviada!',
        description: 'Tu postulación ha sido enviada exitosamente. La revisaremos y te contactaremos pronto.'
      },
      error: {
        title: 'Error al Enviar',
        description: 'Hubo un error al enviar tu postulación. Por favor intenta nuevamente.'
      }
    },
    
    // Dashboard
    dashboard: {
      title: 'Panel de Control',
      welcome: 'Bienvenido de nuevo',
      newApplication: 'Nueva Postulación',
      totalPrograms: 'Total de Desafíos',
      activePrograms: 'Desafíos Activos',
      totalApplications: 'Total de Postulaciones',
      avgScore: 'Puntaje Promedio',
      tabs: {
        programs: 'Mis Desafíos',
        applications: 'Postulaciones',
        analytics: 'Analítica'
      },
      programsTab: {
        title: 'Desafíos',
        view: 'Ver'
      },
      applicationsTab: {
        title: 'Postulaciones Recientes',
        startupName: 'Nombre de Startup',
        program: 'Desafío',
        submitted: 'Enviado',
        status: 'Estado',
        score: 'Puntaje',
        pending: 'Pendiente'
      },
      analyticsTab: {
        topCategories: 'Principales Categorías',
        applicationsByMonth: 'Postulaciones por Mes'
      }
    },
    
    // Solutions Page
    solutions: {
      hero: {
        title: 'Planes y Precios',
        subtitle: 'Publica desafíos, evalúa con humanos + IA y selecciona a los mejores postulantes.'
      },
      toggle: {
        monthly: 'Mensual',
        annual: 'Anual',
        save: 'Ahorra 2 meses'
      },
      plans: {
        starter: {
          name: 'Starter',
          monthlyPrice: '39',
          annualPrice: '390',
          tagline: 'Ideal para PyMEs, municipios, universidades y equipos de innovación que quieren empezar.',
          features: [
            'Desafíos ilimitados',
            'Evaluadores IA para preevaluar postulaciones',
            'Plantillas guiadas para definir bien tu desafío',
            'Difusión básica en la plataforma',
            'Acceso completo a todas las postulaciones recibidas',
            'Dashboard simple de seguimiento',
            'Publicación inmediata (sin validaciones comerciales)'
          ],
          notIncluded: [
            'Curaduría de soluciones',
            'Soporte humano dedicado',
            'Workshops o asesorías'
          ],
          cta: 'Comenzar ahora'
        },
        growth: {
          name: 'Growth',
          monthlyPrice: '129',
          annualPrice: '1.290',
          tagline: 'Para organizaciones que quieren resultados, no solo publicar.',
          includesStarter: 'Todo lo del plan Starter más:',
          features: [
            'Revisión experta de hasta 2 desafíos por año (incluida)',
            'Difusión prioritaria en la plataforma y comunidad',
            'Reporting básico de postulaciones',
            'Soporte por email con respuesta en 48 hrs'
          ],
          notIncluded: [
            'Curaduría completa de postulaciones',
            'Workshops estratégicos',
            'Soporte dedicado'
          ],
          idealFor: 'Ideal para: Empresas medianas, gremios, instituciones públicas con presupuesto de innovación.',
          cta: 'Ver este plan'
        },
        pro: {
          name: 'Pro',
          monthlyPrice: '299',
          annualPrice: '2.990',
          tagline: 'Para organizaciones que necesitan escala, acompañamiento y resultados estratégicos.',
          includesGrowth: 'Todo lo del plan Growth más:',
          features: [
            'Curaduría completa de postulaciones incluida',
            'Workshops estratégicos (hasta 2 al año incluidos)',
            'Soporte dedicado con contacto directo',
            'Reporting avanzado con exportación de datos',
            'Prioridad máxima en difusión'
          ],
          idealFor: 'Ideal para: Grandes empresas, corporativos, instituciones financieras, utilities.',
          cta: 'Habla con nosotros'
        }
      },
      period: {
        month: 'mes',
        year: 'año'
      },
      addons: {
        title: 'Servicios opcionales (Add-ons)',
        subtitle: 'Potencia tus resultados con servicios adicionales',
        availableNote: 'Disponible para planes Starter y Growth. Incluido en Plan Pro.',
        items: [
          {
            name: 'Revisión experta del desafío',
            price: 'USD 200',
            description: 'Un experto revisa y mejora la definición de tu desafío'
          },
          {
            name: 'Curaduría de postulaciones',
            price: 'USD 400–600',
            description: 'Análisis y preselección de las mejores postulaciones'
          },
          {
            name: 'Workshop de foco estratégico (4 hrs)',
            price: 'USD 600',
            description: 'Sesión facilitada para definir objetivos y criterios'
          },
          {
            name: 'Gestión completa del desafío',
            price: 'Desde USD 1.500',
            description: 'Nos encargamos de todo el proceso de principio a fin'
          }
        ]
      },
      solvers: {
        title: 'Para solucionadores (startups, emprendedores, academia)',
        price: 'Siempre gratis.',
        description: 'Postular a desafíos en ColaboraChile no tiene costo.',
        belief: 'Creemos en un ecosistema abierto, diverso y activo.'
      },
      faq: {
        title: 'Preguntas frecuentes',
        q1: '¿Por qué no hay plan gratis para publicar desafíos?',
        a1: 'Porque queremos desafíos reales, con organizaciones comprometidas.\nUn pago bajo asegura uso serio y mejores oportunidades para el ecosistema.',
        q2: '¿Puedo cambiar de plan en cualquier momento?',
        a2: 'Sí. Puedes subir o bajar de plan cuando quieras. Los cambios se aplican en el siguiente ciclo de facturación.',
        q3: '¿Qué pasa si necesito más ayuda?',
        a3: 'Puedes contratar add-ons en cualquier momento o subir al Plan Pro para tener soporte dedicado.',
        q4: '¿Hay descuento por pago anual?',
        a4: 'Sí. Al pagar anualmente ahorras el equivalente a 2 meses (~17% de descuento).',
        q5: '¿Necesito hablar con ventas?',
        a5: 'No para los planes Starter y Growth.\nPara el Plan Pro, te recomendamos agendar una llamada.'
      },
      finalCta: {
        title: 'Empieza a evaluar de forma más inteligente hoy',
        subtitle: 'Sin contratos largos. Cancela cuando quieras.',
        cta: 'Comenzar ahora'
      }
    },
    
    // Pricing Page
    pricing: {
      title: 'Precios Simples y Transparentes',
      subtitle: 'Elige el plan que se ajuste a tus necesidades. Comienza gratis, mejora a medida que creces.',
      mostPopular: 'Más Popular',
      perMonth: 'mes',
      getStarted: 'Comenzar',
      contactSales: 'Contactar Ventas',
      faqTitle: 'Preguntas Frecuentes'
    },
    
    // Footer
    footer: {
      description: 'Plataforma abierta y gratuita que conecta desafíos de innovación con soluciones del ecosistema nacional.',
      products: 'Productos',
      compete: 'ColaboraChile Compete',
      browsePrograms: 'Explorar Desafíos',
      pricing: 'Precios',
      company: 'Empresa',
      about: 'Acerca de',
      contact: 'Contacto',
      careers: 'Carreras',
      legal: 'Legal',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
      cookies: 'Política de Cookies',
      copyright: 'Todos los derechos reservados.'
    }
  }
};